/**
 * Sync sample
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type SyncSample = {
	sampleNumber: number;
};
